export default function validateCreateLink(values) {
  const errors = {};
  // Description errors
  if (!values.description) {
    errors.description = 'Description  required';
  } else if (values.description.length < 10) {
    errors.description = 'Description must be at least 10 Characters';
  }

  // url errors
  if (!values.url) {
    errors.url = 'URL required';
  } else if (!/^(ftp|http|https):\/\/[^ "]+$/.test(values.url)) {
    errors.url = 'Invalid URL';
  }
  return errors;
}
